import React from 'react'
import { merge } from 'lodash'
import TextField, { TextFieldProps } from './TextField'

export type ZipCodeFieldProps = TextFieldProps

const ZipCodeField = ({ InputProps, ...rest }: ZipCodeFieldProps) => {
	const mergedInputProps = InputProps
		? merge(InputProps, { maxLength: 5, minLength: 5 })
		: { maxLength: 5, minLength: 5 }
	return <TextField {...rest} InputProps={mergedInputProps} />
}

export default ZipCodeField
